import { Icon, IconProps } from '@elkaso-app/web-design';
import { FaWarehouse } from 'react-icons/fa';

export const ErpMappingsIcons = (props: IconProps) => {
  return <Icon as={FaWarehouse} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
